import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { DashboardDrawer, DashboardQueries } from '@portal/app-admin'

export const Route = createFileRoute('/_auth/preferences/dashboards/$dashboardId')({
  component: EditDashboardRoute,
  loader: async ({ context: { queryClient }, params: { dashboardId } }) => {
    await queryClient.ensureQueryData(DashboardQueries.detail(Number(dashboardId)))
  },
})

function EditDashboardRoute() {
  const { dashboardId } = Route.useParams()
  const navigate = useNavigate()
  return (
    <DashboardDrawer
      dashboardId={Number(dashboardId)}
      onClose={() => void navigate({ to: '/preferences/dashboards' })}
    />
  )
}
